import React, { useState } from 'react';
import i18n from '../../../i18n';
import DynamicValuesPanel from './DynamicValuesPanel';
import { RequestTabState } from '../../../views/AssetCatalog/Transactions/TransactionEditor/RequestTab/RequestTab';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import DataParametersPanel from './DataParametersPanel';
import { getIdForResponseWizard } from '../../../utils/miscUtil';

type ResponseWizardDetailProps = {
  rowData: any;
  requestBodyType: string;
  updateLeafNodeValue: (id: string, value: string) => void;
  requestBodyTreeJson?: string;
  requestTabState: RequestTabState;
  serviceId?: number;
};

type DetailTabTypes = 'dynamicValues' | 'dataParameters';

const ResponseWizardDetail = (props: ResponseWizardDetailProps) => {
  const { rowData, requestBodyType, updateLeafNodeValue, requestBodyTreeJson, requestTabState } = props;
  const [activeTab, setActiveTab] = useState<DetailTabTypes>('dynamicValues');
  const rowId = getIdForResponseWizard(rowData);
  return (
    <React.Fragment>
      <div className={'mt-5 ml-8 pl-0'}>
        <ButtonGroup className={'float-right mr-4 p-relative'} style={{ top: '27px' }}>
          <Button
            size={'sm'}
            variant={activeTab === 'dynamicValues' ? 'primary' : 'secondary'}
            onClick={() => setActiveTab('dynamicValues')}
          >
            {i18n.t('transactions:editor.dynamicValues')}
          </Button>
          <Button
            size={'sm'}
            variant={activeTab === 'dataParameters' ? 'primary' : 'secondary'}
            onClick={() => setActiveTab('dataParameters')}
          >
            {i18n.t('transactions:editor.dataParameters')}
          </Button>
        </ButtonGroup>
        <div>
          <h4>
            {activeTab === 'dynamicValues'
              ? i18n.t('transactions:editor.dynamicValues')
              : i18n.t('transactions:editor.dataParameters')}
          </h4>
          <label className={'font-size-medium font-weight-normal mb-0'}>
            {activeTab === 'dynamicValues'
              ? i18n.t('transactions:editor.dynamicValuesSubTitle')
              : i18n.t('transactions:editor.dataParamsSubTitle')}
          </label>
        </div>
      </div>
      <div className="mt-0 ml-8 mr-4 pl-0">
        {activeTab === 'dynamicValues' && (
          <DynamicValuesPanel
            requestBodyTreeJson={requestBodyTreeJson}
            requestTabState={requestTabState}
            updateNodeValue={updateLeafNodeValue}
            requestBodyType={requestBodyType}
            id={rowId}
          />
        )}

        <div style={{ display: activeTab === 'dataParameters' ? 'block' : 'none' }}>
          <DataParametersPanel
            onParameterSelected={(value: string) => updateLeafNodeValue(rowId, value)}
            key={props.serviceId}
            serviceId={props.serviceId}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ResponseWizardDetail;
